import { Brand, createBranded } from '@deltasierra/type-utilities';

/**
 * @deprecated Use the `LearnSectionId` instead.
 */
export type TryThisSectionId = Brand<number, 'TryThisSectionId'>;
/**
 * @deprecated Use the `LearnSectionId` instead.
 */
export const TryThisSectionId = createBranded<TryThisSectionId>();
